document.addEventListener('DOMContentLoaded', function() {
    if ( document.querySelectorAll('.page__fd__media_swiper.swiper').length > 0 ){
        document.querySelectorAll('.page__fd__media_swiper.swiper').forEach((swiperinitilize) => {
            new Swiper(swiperinitilize, {
            pagination: { el: ".swiper-pagination", clickable: true },
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"}         
            });
        }); 
    }

    class CustomSelectionVariant extends HTMLElement{
        constructor(){
        super();
        this.querySelectorAll('input[type="radio"]').forEach((elm)=>{
            elm.addEventListener('change', ()=>{
            this.updateRadioOption();
            })
        })
        }
        updateRadioOption(){
        this.updateOptions();
        this.updateMasterId();
        this.updatequickadd();
        }
        updateOptions() {
        this.options = Array.from(this.querySelectorAll('input[type="radio"]:checked'), (input) => input.value);
        }   
        updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
            return this.options[index] === option;
            }).includes(false);
        });
        }   
        getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
        }
        // edited by Skio
        getProductData() {
          return this.productData ||= JSON.parse(this.querySelector('[data-product]').textContent);
        }  
        updatequickadd(){
        if(this.currentVariant){
            this.closest('.page_fd__image_content').querySelector('[name="id"]').value = this.currentVariant.id;
            
            // Filter to only use selling plans from app_id 5859381
            // edited by Skio
            const productData = this.getProductData();
            const filteredSellingPlanGroups = productData.selling_plan_groups.filter(selling_plan_group => 
              selling_plan_group.app_id === 'SKIO'
            );
            
            // Get valid selling plan IDs from filtered groups
            const validPlanIds = new Set();
            filteredSellingPlanGroups.forEach(group => {
              if (group.selling_plans) {
                group.selling_plans.forEach(plan => validPlanIds.add(plan.id));
              }
            });
            
            // Find first matching allocation
            const validAllocation = this.currentVariant.selling_plan_allocations.find(allocation =>
              validPlanIds.has(allocation.selling_plan_id)
            );
            
            if (validAllocation) {
              this.closest('.page_fd__image_content').querySelector('[name="selling_plan_id"]').value = validAllocation.selling_plan_id;
              this.closest('.page_fd__image_content').querySelector('[name="selling_plan"]').value = validAllocation.selling_plan_id;
            } else {
              console.warn('No selling plan allocations found for app_id SKIO');
              this.closest('.page_fd__image_content').querySelector('[name="selling_plan_id"]').value = this.currentVariant.selling_plan_allocations[0].selling_plan_id; // fallback
              this.closest('.page_fd__image_content').querySelector('[name="selling_plan"]').value = this.currentVariant.selling_plan_allocations[0].selling_plan_id; // fallback
            }
            // edited by Skio
            if( this.currentVariant.available && (this.currentVariant.compare_at_price > this.currentVariant.price) ){
            this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).disabled = false;
            this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).innerHTML = `Add to Cart —&nbsp;$${(this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2)} <s>${(this.currentVariant.compare_at_price / 100).toFixed(2)}</s>`;
            }else if(this.currentVariant.available){
            this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).disabled = false;
            this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).innerHTML = `Add to Cart —&nbsp;$${(this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2)} <s>${(this.currentVariant.price / 100).toFixed(2)}</s>`;          
            }else if( !this.currentVariant.available && (this.currentVariant.compare_at_price > this.currentVariant.price) ){
            this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).disabled = true;
            this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).innerHTML = `Sold Out —&nbsp;$${(this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2)} <s>${(this.currentVariant.compare_at_price / 100).toFixed(2)}</s>`;
            }else if(!this.currentVariant.available){
            this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).disabled = true;
            this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).innerHTML = `Sold Out —&nbsp;$${(this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2)} <s>${(this.currentVariant.price / 100).toFixed(2)}</s>`;          
            }      
        }
        }
    }
    customElements.define('cus-variant-radios',CustomSelectionVariant)
    
    document.querySelectorAll('.js-mainproduct-submit').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
        target.preventDefault();
            target.target.closest('.product-form__buttons').querySelector('button').classList.add('loading');
            target.target.closest('.product-form__buttons').querySelector('button').disabled = true;          
            let Etarget = target.target;
            let sellingId = target.target.closest('.product__form_object').querySelector('.product-form').querySelector('form').querySelector('[name="selling_plan"]').value;
            let targetId = target.target.closest('.product__form_object').querySelector('.product-form').querySelector('form').querySelector('[name="id"]').value;
            let productShouldBe = {
            'items': []
            },shouldItem = {
            id: targetId,
            quantity: 1,
            selling_plan: sellingId,
            };
            let cartElement = document.querySelector("cart-drawer");
            if (cartElement) document.querySelector("cart-drawer").enableLoading();    
            productShouldBe.items.push(shouldItem);
            productShouldBe.sections = cartElement.getSectionsToRender().map((section) => section.section);
            productShouldBe.sections_url = window.location.pathname 
            fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(productShouldBe),
            credentials: 'same-origin'
            }).then((response) => response.json())
            .then((parsedState) => {
            cartElement.renderContent(parsedState.sections);
            })
            .catch((e) => {
            console.error(e);
            })
            .finally(() => {
            if (cartElement) {
                document.querySelector("cart-drawer").disableLoading();
                document.querySelector("cart-drawer").open();
                Etarget.closest('.product__form_object').querySelector('.product-form').querySelector('form').querySelector('.product-form__buttons').querySelector('button').classList.remove('loading');
                Etarget.closest('.product__form_object').querySelector('.product-form').querySelector('form').querySelector('.product-form__buttons').querySelector('button').disabled = false;                 
            }
            });       
        })
    })  
})